import { createContext } from "react";

export interface CookieConsent {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
}

export interface CookieContextType {
  consent: CookieConsent | null;
  saveConsent: (consent: CookieConsent) => void;
  bannerOpen: boolean;
  setBannerOpen: (open: boolean) => void;
  settingsOpen: boolean;
  setSettingsOpen: (open: boolean) => void;
}

export const CookieContext = createContext<CookieContextType | undefined>(undefined);
